var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ChatbotAiPrompt" } }, [
    _c(
      "div",
      [
        _c("h1", [_vm._v("Chatbot AI Prompt")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n                Artificial intelligence learns and determines how it should behave by being given instructions about a\n                specific task or problem using the 'prompt' feature.\n            "
          ),
        ]),
        _vm._v(" "),
        _c("a-textarea", {
          staticStyle: { "min-height": "200px" },
          attrs: {
            placeholder: "Enter the prompt",
            "auto-size": { minRows: 2 },
          },
          model: {
            value: _vm.promptText,
            callback: function ($$v) {
              _vm.promptText = $$v
            },
            expression: "promptText",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { key: _vm.key, staticClass: "parameter-tuning" }, [
      _c("h1", [_vm._v("AI Parameter Tunings")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                You can tune the AI parameters to make the AI more responsive and accurate. These parameters are used to\n                control the AI's behavior and how it responds to user inputs.\n            "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.story.ai
            ? _c("FeatureItem", {
                attrs: {
                  title: "Tempature",
                  icon: "ChatAiIcon",
                  description:
                    "What sampling temperature to use, between 0 and 2. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic.",
                  type: "number",
                  min: 0.01,
                  max: 2,
                  step: 0.1,
                  "number-format": "float",
                },
                model: {
                  value: _vm.temperature,
                  callback: function ($$v) {
                    _vm.temperature = $$v
                  },
                  expression: "temperature",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.story.ai
            ? _c("FeatureItem", {
                attrs: {
                  title: "Top-P",
                  icon: "ChatAiIcon",
                  description:
                    "An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So 0.1 means only the tokens comprising the top 10% probability mass are considered.\nWe generally recommend altering this or temperature but not both.",
                  type: "number",
                  min: 0.01,
                  max: 1,
                  step: 0.1,
                  "number-format": "float",
                },
                model: {
                  value: _vm.topP,
                  callback: function ($$v) {
                    _vm.topP = $$v
                  },
                  expression: "topP",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modes" }, [
        _c("strong", [_vm._v(" Tool Choices ")]),
        _vm._v(" "),
        _c(
          "div",
          { key: _vm.key, staticClass: "mode-items" },
          [
            _vm.story.ai
              ? _c("FeatureItem", {
                  attrs: {
                    title: "None",
                    icon: "ChatAiIcon",
                    description:
                      "None means the model will not call any tools and instead generates a message",
                    type: "switch",
                  },
                  model: {
                    value: _vm.toolChoiceNone,
                    callback: function ($$v) {
                      _vm.toolChoiceNone = $$v
                    },
                    expression: "toolChoiceNone",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.story.ai
              ? _c("FeatureItem", {
                  attrs: {
                    title: "Auto",
                    icon: "ChatAiIcon",
                    description:
                      "Auto mode is the default value and means the model can pick between generating a message or calling one or more tools.",
                    type: "switch",
                  },
                  model: {
                    value: _vm.toolChoiceAuto,
                    callback: function ($$v) {
                      _vm.toolChoiceAuto = $$v
                    },
                    expression: "toolChoiceAuto",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.story.ai
              ? _c("FeatureItem", {
                  attrs: {
                    title: "Required",
                    icon: "ChatAiIcon",
                    description:
                      "Required mode is  the model must call one or more tools before responding to the user",
                    type: "switch",
                  },
                  model: {
                    value: _vm.toolChoiceRequired,
                    callback: function ($$v) {
                      _vm.toolChoiceRequired = $$v
                    },
                    expression: "toolChoiceRequired",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "settings-btn" },
      [
        _c(
          "SupsisButton",
          { attrs: { ghost: "" }, on: { click: _vm.clearPrompt } },
          [_vm._v(" Cancel")]
        ),
        _vm._v(" "),
        _c(
          "SupsisButton",
          { attrs: { primary: "" }, on: { click: _vm.updatePrompt } },
          [_vm._v("Save")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }